var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section a-section a-section--fullheight"},[_c('div',{staticClass:"a-flex"},[_vm._v(" "+_vm._s(_vm.info)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }